import { groupBy } from 'lodash';
import dayjs from 'dayjs';
import {
  License,
  LicenseEntitlement,
  LicenseStatus,
  LicenseType,
} from '../../../types';
import { licenseEntitlements } from '../../../constants';

export const mapLicense = (licenses: License[]) => {
  const sortedLicenses = licenses
    .map((l) => ({
      ...l,
      status:
        l.status === LicenseStatus.ACTIVE && dayjs(l.startDate).isAfter(dayjs())
          ? LicenseStatus.IN_COMING
          : l.status,
    }))
    .sort((a, b) => {
      if (dayjs(a.startDate).isSame(dayjs(b.startDate))) {
        if (dayjs(a.endDate).isSame(dayjs(b.endDate))) {
          if (a.status === b.status) {
            return a.type === LicenseType.PRODUCTION ? -1 : 1;
          }
          return a.status === LicenseStatus.ACTIVE ? -1 : 1;
        }
        return dayjs(a.endDate).isAfter(dayjs(b.endDate)) ? -1 : 1;
      }
      if (dayjs(a.startDate).isAfter(dayjs(b.startDate))) {
        return -1;
      }

      return 1;
    });

  const groupedLicense = groupBy(sortedLicenses, 'entitlement');

  const mappedLicense = licenseEntitlements
    .map((e) => {
      const licensesForEntitlement = groupedLicense[e.id];
      return {
        ...e,
        licenses: licensesForEntitlement,
        isTrial:
          licensesForEntitlement?.length === 1 &&
          licensesForEntitlement[0].type === LicenseType.TRIAL,
      };
    })
    .sort((a, b) => {
      if (a.id === LicenseEntitlement.CORE) {
        return 1;
      }
      if (a.licenses?.length && !b.licenses?.length) {
        return -1;
      }

      return 0;
    });

  return mappedLicense;
};
